import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { firstValueFrom, Subscription } from 'rxjs';
import { ModalObjectType } from 'src/app/interfaces/modal-object-types.interface';
import { ProviderInvoiceModel } from 'src/app/models/shopping/provider-invoice.model';
import { ProviderInvoiceService } from 'src/app/services/shopping/provider-invoice.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-prefix-invoice-number',
  templateUrl: './prefix-invoice-number.component.html',
  styleUrls: ['./prefix-invoice-number.component.scss'],
  standalone: false
})
export class PrefixInvoiceNumberComponent implements OnInit {

  public readonly config = inject(DynamicDialogConfig);
  private readonly formBuilder = inject(FormBuilder);
  private readonly providerInvoiceService = inject(ProviderInvoiceService);
  private readonly ref = inject(DynamicDialogRef);
  private readonly toastHandlerService = inject(ToastHandlerService);

  disabledActions: boolean = false;
  formProviderInvoice: FormGroup = new FormGroup({});
  permissionUpdatable: boolean = false;
  providerInvoiceModel: ProviderInvoiceModel = new ProviderInvoiceModel();
  suscription: Subscription;
  updateProviderInvoice: boolean = false;

  async ngOnInit(): Promise<void> {
    this.validateForm(new ProviderInvoiceModel());

    const input$ = this.config.data?.inputs$;
    if (!input$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }

    this.suscription = input$?.subscribe((inputs: any) => {
      this.providerInvoiceModel = inputs.providerInvoiceModel;
      this.permissionUpdatable = inputs.permissionUpdatable;
      this.disabledActions = inputs.disabledForm;
    });

    this.validateForm(this.providerInvoiceModel);

    if (this.disabledActions) {
      this.formProviderInvoice.disable();
    } else {
      this.formProviderInvoice.enable();
    }
  }

  ngOnDestroy() {
    this.suscription?.unsubscribe();
  }

  close() {
    const data: ModalObjectType = {};
    data.params = { updateProviderInvoice: this.updateProviderInvoice };
    this.ref.close(data);
  }

  async send() {
    Object.keys(this.formProviderInvoice.controls).forEach((key) => {
      const control = this.formProviderInvoice.get(key);
      if (control && control.invalid) {
        console.warn(`${key} es inválido`, control.errors, 'value:', control.value);
      }
    });
    if (this.formProviderInvoice.valid) {
      let prefix = this.formProviderInvoice.get("prefix")?.value;
      const invoiceNumber = this.formProviderInvoice.get("invoiceNumber")?.value;
      if (prefix.trim() === '') prefix = null;

      this.providerInvoiceModel.prefix = prefix;
      this.providerInvoiceModel.invoiceNumber = invoiceNumber;
      try {
        await firstValueFrom(this.providerInvoiceService.updateProviderInvoice(this.providerInvoiceModel));
        this.updateProviderInvoice = true;
        this.toastHandlerService.showToast('success', `La factura proveedor se modificó exitosamente.`);
      } catch (error) {
        console.error('Error al guardar la factura proveedor.', error);
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      prefix: {
        required: 'Debe ingresar el prefijo',
        maxlength: 'El prefijo no puede tener más de 6 caracteres'
      },
      invoiceNumber: {
        required: 'Debe ingresar el número de factura',
        min: 'Debe ingresar un número de factura mayor a 0'
      }
    };
    Object.keys(controlMessages).forEach(controlName => {
      const control = this.formProviderInvoice.get(controlName);
      if (control && control.invalid && control.errors) {
        const messages = controlMessages[controlName];
        Object.keys(control.errors).forEach(errorKey => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  validateForm(providerInvoiceModel: ProviderInvoiceModel) {
    this.formProviderInvoice = this.formBuilder.group({
      prefix: [providerInvoiceModel.prefix, [Validators.maxLength(6)]],
      invoiceNumber: [providerInvoiceModel.invoiceNumber, [Validators.required, Validators.min(1)]]
    });
  }

}
